import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import isEmpty from 'lodash/isEmpty'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

let routeStatus = ''

router.beforeEach((to, from, next) => {
  let store = router.app.$store
  const profile = store.getters['auth/profile']
  if (to.name === 'Login' && profile) {
    next({ name: 'Dashboard' })
  } else if (!profile && to.name !== 'Login') {
    next({ name: 'Login' })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  let store = router.app.$store
  store.commit('app/setRouteStatus', routeStatus ? routeStatus : 'ok')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js